import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import VenturesGrid from "./components/VenturesGrid";
import VenturesHeader from "./components/VenturesHeader";

const sectionVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 },
};

const Ventures: React.FC = () => {
  const { ref, inView } = useInView({ threshold: 0.1 });

  return (
    <motion.div
      ref={ref}
      className="h-full flex flex-col"
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={sectionVariants}
      transition={{ duration: 0.8, ease: "easeOut", staggerChildren: 0.2 }}
    >
      <VenturesHeader />
      <div className="flex-1">
        <VenturesGrid />
      </div>
    </motion.div>
  );
};

export default Ventures;
